<template>
  <div class="genesSelect">
    <v-alert v-if="errored" v-show="showError" type="error" dark width="500px" dismissible>
      {{ errormsg }}
    </v-alert>
    <template v-else>
      <img src="@/assets/logo.png" width="300px" />
      <h1>
        <i>{{ getCurrentSpeciesLabel }}</i>
      </h1>
      <h3>
        {{ getSelectedReleaseName }}
        <show-parameters-button
          tooltip="Release information"
          @click="displayReleaseInfoDialog = true"
        ></show-parameters-button>
      </h3>
      <release-information-dialog
        v-if="displayReleaseInfoDialog"
        :genotypes="getGenotypes"
        :release="getSelectedReleaseName"
        :locinb="activeLociNumber"
        @close="displayReleaseInfoDialog = false"
      ></release-information-dialog>

      <loading-dialog :loading="loading || searching"></loading-dialog>
      <v-row dense justify="space-between">
        <v-col cols="4">
          <locus-selection-panel
            v-if="loading === false"
            :known-locus-id="activeLocusIds"
            @changeLocusId="loadGene"
          ></locus-selection-panel>
        </v-col>
        <v-col cols="8">
          <locus-selection-filter-v-card
            v-if="loading === false"
            @selectLocusId="loadGene"
            @startSearch="searching = true"
            @stopSearch="searching = false"
          ></locus-selection-filter-v-card>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import LocusSelectionPanel from '@/components/locus/LocusSelectionPanel.vue';
import LocusSelectionFilterVCard from '@/components/locus/LocusSelectionFilterVCard.vue';
import LoadingDialog from '@/components/generic/LoadingDialog.vue';
import ReleaseInformationDialog from '@/components/generic/ReleaseInformationDialog.vue';
import ShowParametersButton from '@/components/generic/buttons/ShowParametersButton.vue';
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';
import { mapMutations } from 'vuex';

export default {
  components: {
    LocusSelectionPanel,
    LocusSelectionFilterVCard,
    LoadingDialog,
    ReleaseInformationDialog,
    ShowParametersButton,
  },
  props: {
    species: {
      type: String,
      default: '',
      required: true,
    },
    release: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeLocusIds: [],
      loading: true,
      searching: false,
      displayReleaseInfoDialog: false,
      selectReleaseId: this.release,
      errored: false,
      errormsg: 'Error during loci research',
      showError: false,
    };
  },
  computed: {
    activeLociNumber() {
      return this.activeLocusIds.length;
    },
    ...mapGetters([
      'getListOfGenesId',
      'getListOfGeneIdByAnnot',
      'getSelectedGeneNumber',
      'getSelectedReleaseName',
      'getDefaultRelease',
      'getCurrentSpeciesLabel',
      'getSpecies',
      'getRelease',
      'getGenotypes',
      'getErrorMsg',
    ]),
  },
  watch: {
    release: function(newRelease) {
      this.selectReleaseId = newRelease;
      this.reloadData();
    },
  },
  mounted() {
    this.reloadData();
  },

  methods: {
    ...mapActions([
      'fetchListOfSpecies',
      'fetchListOfReleases',
      'fetchListOfGenes',
      'fetchListOfGeneByAnnot',
      'loadRelease',
    ]),
    ...mapMutations(['setCurrentSpecies']),
    /**
     * First load the list of species, assert the selected species belows to this list
     * Second load the list of releases, assert the selected release belong to this list
     * Third get the list of loci available for this release
     */
    reloadData() {
      this.loading = true;
      // search the available species
      this.fetchListOfSpecies()
        .then(
          () => {
            if (!this.getSpecies(this.species)) {
              this.displayError('Unknown species ' + this.species);
            } else {
              this.setCurrentSpecies(this.species);
              // search the available releases
              this.fetchListOfReleases().then(
                () => {
                  if (this.selectReleaseId === '') {
                    this.selectReleaseId = this.getDefaultRelease.id;
                  }
                  if (!this.getRelease(this.selectReleaseId)) {
                    this.displayError(
                      'Unknown Release with the identifier ' + this.selectReleaseId
                    );
                  } else {
                    this.loadRelease(this.selectReleaseId).then(
                      () => {
                        // search thye available loci of this release
                        this.fetchListOfGenes().then(
                          () => {
                            this.activeLocusIds = this.getListOfGenesId;
                            this.loading = false;
                          },
                          () => {
                            this.errored = true;
                            this.loading = false;
                          }
                        );
                      },
                      () => {
                        this.errored = true;
                        this.loading = false;
                      }
                    );
                  }
                },
                () => {
                  this.errored = true;
                  this.loading = false;
                }
              );
            }
          },
          () => {
            this.errored = true;
            this.loading = false;
          }
        )
        .catch(() => {
          this.displayError('Error during loading species');
          this.loading = false;
        });
    },
    loadGene(geneId) {
      this.$router.push(`/${this.species}/${this.selectReleaseId}/${geneId}`);
    },
    clearLociSelection() {
      this.activeLocusIds = this.getListOfGenesId;
    },
    displayError(msg) {
      this.showError = true;
      this.errored = true;
      this.errormsg = msg;
    },

    filterAnnot(o) {
      this.loading = true;
      this.fetchListOfGeneByAnnot(o.keyword, o.minallelenb).then(() => {
        this.activeLocusIds = this.getListOfGeneIdByAnnot;
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.genesSelect {
  max-width: 1000px;
  margin: auto;
  text-align: center;
}
button {
  margin: 50px;
}

img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: -130px;
}

.v-alert {
  margin: 100px auto;
}
</style>
